<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="等级" prop="level" >
        <a-input-number :min="0" :step="1" v-model="form.level" placeholder="请输入等级" />
      </a-form-model-item>
      <a-form-model-item label="魅力值" prop="charmNum" >
        <a-input-number :min="0" v-model="form.charmNum" placeholder="请输入魅力值" />
      </a-form-model-item>
      <a-form-model-item label="分销比例" prop="distributionRatio" >
        <a-input-number :min="0" :max="1" :step="0.01" v-model="form.distributionRatio" placeholder="请输入分销比例" />
      </a-form-model-item>
      <a-form-model-item label="文字聊天花费-最大值" prop="chatPriceTextMax" >
        <a-input-number :min="0" :max="99999" :step="1" v-model="form.chatPriceTextMax" placeholder="请输入分销比例" />
      </a-form-model-item>
      <a-form-model-item label="语音聊天花费-最大值" prop="chatPriceVoiceMax" >
        <a-input-number :min="0" :max="99999" :step="1" v-model="form.chatPriceVoiceMax" placeholder="请输入分销比例" />
      </a-form-model-item>
      <a-form-model-item label="视频聊天花费-最大值" prop="chatPriceVideoMax" >
        <a-input-number :min="0" :max="99999" :step="1" v-model="form.chatPriceVideoMax" placeholder="请输入分销比例" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getFriendCharm, addFriendCharm, updateFriendCharm } from '@/api/user/friendCharm'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        level: null,

        charmNum: null,

        distributionRatio: null,

        chatPriceTextMax: null,

        chatPriceVoiceMax: null,

        chatPriceVideoMax: null,

        cateName: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        level: [
          { required: true, message: '等级不能为空', trigger: 'blur' }
        ],
        charmNum: [
          { required: true, message: '魅力值不能为空', trigger: 'blur' }
        ],
        distributionRatio: [
          { required: true, message: '分销比例不能为空', trigger: 'blur' }
        ],
        chatPriceTextMax: [
          { required: true, message: '文字聊天花费-最大值不能为空', trigger: 'blur' }
        ],
        chatPriceVoiceMax: [
          { required: true, message: '语音聊天花费-最大值不能为空', trigger: 'blur' }
        ],
        chatPriceVideoMax: [
          { required: true, message: '视频聊天花费-最大值不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        level: null,
        charmNum: null,
        distributionRatio: null,
        chatPriceTextMax: null,
        chatPriceVoiceMax: null,
        chatPriceVideoMax: null,
        cateName: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getFriendCharm({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateFriendCharm(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addFriendCharm(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
